/**
 * NewForm design-system animated icons. Two families, both honouring
 * `prefers-reduced-motion`:
 *
 * Mount-animated (./shared) — hand-drawn SVG in DS brand purple that
 * "draws on" when it appears. For content that arrives on screen:
 *
 *   import { UploadFileIcon, SpreadsheetIcon, DocumentIcon }
 *     from "@/components/ui/design-system/icons";
 *
 * Hover-animated (./hoverIcon) — chrome glyphs that inherit `currentColor`
 * and animate when their icon, link or button is hovered. For persistent
 * controls like toolbar and composer buttons:
 *
 *   import { AttachIcon, ResearchIcon, SendIcon }
 *     from "@/components/ui/design-system/icons";
 */

export { AttachIcon } from "./attach";
export { CheckIcon } from "./check";
export { CloseIcon } from "./close";
export { CopyIcon } from "./copy";
export { DocumentIcon } from "./document";
export { DownloadIcon } from "./download";
export { ExpandIcon } from "./expand";
export { EyeIcon } from "./eye";
export { type HoverIconProps, HoverIconSvg } from "./hoverIcon";
export { JumpDownIcon } from "./jumpDown";
export { LoadingIcon } from "./loading";
export { MicIcon } from "./mic";
export { OpenModalIcon } from "./openModal";
export { PauseIcon } from "./pause";
export { PlayIcon } from "./play";
export { PlusIcon } from "./plus";
export { ResearchIcon } from "./research";
export { RocketIcon } from "./rocket";
export { SendIcon } from "./send";
export type { AnimatedIconProps } from "./shared";
export { ShieldIcon } from "./shield";
export { SidebarToggleIcon } from "./sidebarToggle";
export { SpreadsheetIcon } from "./spreadsheet";
export { StopIcon } from "./stop";
export { ThumbsDownIcon } from "./thumbsDown";
export { ThumbsUpIcon } from "./thumbsUp";
export { UploadFileIcon } from "./uploadFile";
export { VideoCameraIcon } from "./videoCamera";
